const prefix = "NOTIFICATION_";

export class NotificationConstants {
    public static ADD: string = prefix + "ADD";
    public static REMOVE: string = prefix + "REMOVE";
    public static HIDE: string = prefix + "HIDE";
    public static SHOW: string = prefix + "SHOW";
}



// WEBPACK FOOTER //
// ./src/constants/notifications.ts